// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rq7Dexb0gKH4nyxdEopA {
	display: flex;
	justify-content: center;
	border-radius: 6px;
	padding: 2px 15px;
	font-size: 12px;
	line-height: 1.3;
	background-color: #ffa900;
	color: #fff;
	position: absolute;
	right: -8px;
	top: -8px;
}

.iXHB4YrMe83TnXOEbgzw {
	position: relative;
}

.kOrEF3b9Lw23YV9MeExg {
	letter-spacing: 0;
}

@media screen and (max-width: 1300px) {

.kOrEF3b9Lw23YV9MeExg {
		display: none;
}
	}
`, "",{"version":3,"sources":["webpack://./src/components/Header/HeaderTabs.pcss"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,uBAAuB;CACvB,kBAAkB;CAClB,iBAAiB;CACjB,eAAe;CACf,gBAAgB;CAChB,yBAAyB;CACzB,WAAW;CACX,kBAAkB;CAClB,WAAW;CACX,SAAS;AACV;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;AAIlB;;AAHC;;AAFD;EAGE,aAAa;AAEf;CADC","sourcesContent":[".new {\n\tdisplay: flex;\n\tjustify-content: center;\n\tborder-radius: 6px;\n\tpadding: 2px 15px;\n\tfont-size: 12px;\n\tline-height: 1.3;\n\tbackground-color: #ffa900;\n\tcolor: #fff;\n\tposition: absolute;\n\tright: -8px;\n\ttop: -8px;\n}\n\n.tab {\n\tposition: relative;\n}\n\n.tabsContainer {\n\tletter-spacing: 0;\n\t@media screen and (max-width: 1300px) {\n\t\tdisplay: none;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"new": `rq7Dexb0gKH4nyxdEopA`,
	"tab": `iXHB4YrMe83TnXOEbgzw`,
	"tabsContainer": `kOrEF3b9Lw23YV9MeExg`
};
export default ___CSS_LOADER_EXPORT___;
